import React from 'react'
import MetarDetailSection from './MetarDetailSection'
import MetarDetailSectionItem from './MetarDetailSectionItem'
import * as temperature from '../util/temperature'

const MetarDetailTempDew = props => {
  if(!props.temperature || !props.dewpoint) {
    return null
  }
  return (
    <MetarDetailSection
      className={props.className}
      title={"TEMP/DEWPOINT"}
    >
      <MetarDetailSectionItem
        header={"TEMP"}
        value={props.temperature + "°C"}
        footer={Math.round(temperature.convertToFahrenheit(props.temperature)) + "°F"}
      />
      <MetarDetailSectionItem
        header={"DEW"}
        value={props.dewpoint + "°C"}
        footer={Math.round(temperature.convertToFahrenheit(props.dewpoint)) + "°F"}
      />
    </MetarDetailSection>
  )
}

export default MetarDetailTempDew



// WEBPACK FOOTER //
// ./src/components/MetarDetailTempDew.js